import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import CandidateSidebar from "../components/candidate/sidebar/CandidateSidebar";
import PersonalInfo from "../components/candidate/personal-info/personal-info";
import AddressInfo from "../components/candidate/address-info/AddressInfo";
import EducationStepper from "../components/candidate/education-info/EducationStepper";
import EmploymentDetails from "../components/candidate/employment-info/EmploymentDetails";
import Declaration from "../components/candidate/declaration/Declaration";
import Instructions from "../components/candidate/instructions/Instructions";
import NewEmployement from "../components/candidate/employment-info/NewEmployement";
import EditEmployeement from "../components/candidate/employment-info/EditEmployeement";
import CandidateDashboard from "../components/candidate/CandidateDashboard/candidate-Dashboard";
import CandidateChatbot from "../components/candidate/chatbot/CandidateChatbot";
import DigiLockerVerification from "../components/candidate/digilockerrouter/DigiLockerVerification";

import CandidateRouteGuard from "../components/candidate/CandidateRouteGuard";
import { CandidateStatusProvider } from "../components/candidate/CandidateStatusContext";
import ForbiddenPage from "../forbidden/ForbiddenPage";
import NotFoundPage from "../forbidden/NotFoundPage";

const CandidateRoutes = () => {
  const location = useLocation();

  const [isSidebarDisabled, setIsSidebarDisabled] = useState(false);

  useEffect(() => {
    setIsSidebarDisabled(
      location.pathname === "/candidate/dashboard" ||
        location.pathname === "/candidate/digilocker-router",
    );
  }, [location]);

  return (
    <CandidateStatusProvider>
      <Routes>
        <Route
          path="/"
          element={<CandidateSidebar isSidebarDisabled={isSidebarDisabled} />}
        >
          {/* Default candidate route */}
          <Route index element={<Navigate to="dashboard" replace />} />

          <Route path="candidate-dashboard" element={<CandidateDashboard />} />

          <Route path="dashboard" element={<Instructions />} />

          <Route
            path="personal-info"
            element={
              <CandidateRouteGuard requiredRequest="PERSONAL_DETAILS">
                <PersonalInfo />
              </CandidateRouteGuard>
            }
          />

          <Route
            path="address-info"
            element={
              <CandidateRouteGuard requiredRequest="ADDRESS_DETAILS">
                <AddressInfo />
              </CandidateRouteGuard>
            }
          />

          <Route
            path="education-info"
            element={
              <CandidateRouteGuard requiredRequest="EDUCATION_DETAILS">
                <EducationStepper />
              </CandidateRouteGuard>
            }
          />

          <Route
            path="employment-info"
            element={
              <CandidateRouteGuard requiredRequest="EMPLOYMENT_DETAILS">
                <EmploymentDetails />
              </CandidateRouteGuard>
            }
          />

          <Route
            path="new-employment"
            element={
              <CandidateRouteGuard requiredRequest="EMPLOYMENT_DETAILS">
                <NewEmployement />
              </CandidateRouteGuard>
            }
          />

          <Route
            path="edit-employment/:id"
            element={
              <CandidateRouteGuard requiredRequest="EMPLOYMENT_DETAILS">
                <EditEmployeement />
              </CandidateRouteGuard>
            }
          />

          <Route path="declaration" element={<Declaration />} />

          {/* <Route
            path="chatbot"
            element={<CandidateChatbot />}
          /> */}

          <Route
            path="digilocker-router"
            element={<DigiLockerVerification />}
          />

          <Route path="*" element={<NotFoundPage />}>
            {" "}
          </Route>
        </Route>
      </Routes>
    </CandidateStatusProvider>
  );
};

export default CandidateRoutes;
